import React, { useEffect, useMemo, useState } from 'react';
import TableLayout from '../components/molecules/TableLayout';
import Table from '../components/molecules/Table';
import { BsThreeDotsVertical } from 'react-icons/bs';
import { BiSolidShow } from 'react-icons/bi';
import { BiSolidHide } from 'react-icons/bi';
import { RxReload } from 'react-icons/rx';
import Button from '../components/molecules/Button';
import ModalContainer from '../components/molecules/ModalContainer';
import Select from '../components/molecules/Select';
import AddDeviceModal from '../components/atoms/AddDeviceModal';
import CenterModal from '../components/molecules/Modal/CenterModal';
import SuccessModal from '../components/atoms/SuccessModal';
import { HiTrash } from 'react-icons/hi2';
import { HiPencil } from 'react-icons/hi2';
import { MdBlock } from 'react-icons/md';
import DeleteModal from '../components/atoms/DeleteModal';
import { useContextHook } from 'use-context-hook';
import { AuthContext } from '../Context/authContext';
import deviceService from '../services/deviceService';
import { useNavigate, useParams } from 'react-router-dom';
import { format } from 'date-fns';
import { getDateObject } from '../helpers/common';
import { FaArrowLeft } from 'react-icons/fa';
import Toast from '../components/molecules/Toast';
import storeService from '../services/storeService';
import MenuButton, { MenuItem } from '../components/atoms/Menu';
import DeviceActivationCode from '../components/atoms/DeviceActivationCode';
import { ActionsWrapper } from '../styles/helpers.styles';

const Devices = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [searchQuery, setSearchQuery] = useState({
    page: 1,
    itemsPerPage: 5,
    searchText: '',
    type: 'all',
    startDate: '',
    endDate: '',
    storeId: id,
    getStoreInfo: true,
    filterStatus: '',
  });
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteModalSuccess, setDeleteModalSuccess] = useState(false);
  const [rowSN, setRowSN] = useState(null);
  const [idToDelete, setIdToDelete] = useState(null);

  const { fetch, refetch, hasPermission } = useContextHook(AuthContext, v => ({
    fetch: v.fetch,
    refetch: v.refetch,
    hasPermission: v.hasPermission,
  }));

  const { devices_data, devices_loading } = deviceService.GetDevices(searchQuery, fetch);
  const { store_details_data } = storeService.GetStoreDetails(id);

  const ConfirmDelete = async () => {
    try {
      await deviceService.deleteDevice(idToDelete);
      Toast({
        message: 'Device Created Successfully',
        type: 'success',
      });
      refetch();
      setDeleteModal(false);
      setDeleteModalSuccess(true);
    } catch (error) {
      Toast({
        type: 'error',
        message: error?.message,
      });
    }
  };
  function handelOtpShow(data) {
    if (rowSN === data) {
      setRowSN(null);
    } else {
      setRowSN(data);
    }
  }
  async function handleReCreateOtp(id) {
    try {
      await deviceService.revokeApiKey(id);
      Toast({
        message: 'Otp Created Successfully',
        type: 'success',
      });
      refetch();
    } catch (error) {
      Toast({
        type: 'error',
        message: error?.message,
      });
    }
  }
  async function handleBlockDevice(id) {
    const status = 'Block';
    try {
      await deviceService.changeDeviceStatus(id, status);
      Toast({
        message: 'Device Blocked Successfully',
        type: 'success',
      });
      refetch();
    } catch (error) {
      Toast({
        type: 'error',
        message: error?.message,
      });
    }
  }

  const actionBtn = _ => (
    <div className="action-btn-dropdown">
      <MenuButton transition icon={<BsThreeDotsVertical size={20} color="#9D9D9D" />}>
        {hasPermission('device.edit') && _?.status === 'Active' && (
          <ModalContainer
            width="669"
            title="Edit Device"
            btnComponent={({ onClick }) => (
              <MenuItem onClick={onClick}>
                <HiPencil size={16} /> Edit Device
              </MenuItem>
            )}
            content={({ onClose }) => <AddDeviceModal data={_} isEdit onSubmit={onClose} />}
          />
        )}
        {hasPermission('device.delete') && _?.status !== 'Deactivated' && (
          <MenuItem
            onClick={() => {
              setDeleteModal(true);
              setIdToDelete(_?._id);
            }}>
            <HiTrash size={16} /> Deactivate Device
          </MenuItem>
        )}
        {hasPermission('device.disable') && (
          <MenuItem onClick={() => handleBlockDevice(_?._id)}>
            <MdBlock size={16} /> Block Device
          </MenuItem>
        )}
      </MenuButton>
    </div>
  );
  const Otp = data => (
    <div className="otp-wrapper">
      <DeviceActivationCode
        targetDate={new Date(data?.activation_code?.created_time)}
        code={data?.activation_code?.otp}
        handelOtpShow={() => handelOtpShow(data?.serial_number)}
        regenrateOtp={() => handleReCreateOtp(data?._id)}
        rowID={rowSN}
        data={data}
      />
    </div>
  );
  const Status = status => {
    switch (status) {
      case 'Active':
        return (
          <div className="status success success-bg-50">
            Active <span className="dot success-bg" />
          </div>
        );
      case 'offline':
        return (
          <div className="status danger danger-bg-50">
            Offline <span className="dot danger-bg" />
          </div>
        );
      case 'Block':
        return (
          <div className="status secondary secondary-bg-50">
            Blocked <span className="dot secondary-bg" />
          </div>
        );
      case 'Deactivated':
        return <div className="status danger danger-bg-50">Deactivated</div>;
      case 'PendingActivation':
        return (
          <div className="status primary primary-bg-50">
            Pending <span className="dot primary-bg" />
          </div>
        );
      default:
        return null;
    }
  };

  const { product_rows, totalCount } = useMemo(() => {
    const items = devices_data?.device;
    return {
      product_rows: items?.map(data => [
        format(getDateObject(data?.created_at), 'yyyy-MM-dd') || '------------',
        data?.title || '------------',
        data?.device_id || '------------',
        data?.serial_number || '------------',
        Status(data?.status),
        Otp(data),
        store_details_data?.passcode || '------------',
        actionBtn(data),
      ]),
      totalCount: items?.length,
    };
  }, [devices_data, Otp]);
  const FilterOptions = [
    {
      value: '',
      label: 'All',
    },
    {
      value: 'Active',
      label: 'Active',
    },
    {
      value: 'Block',
      label: 'Blocked',
    },
    {
      value: 'Deactivated',
      label: 'Deactivated',
    },
    {
      value: 'PendingActivation',
      label: 'Pending',
    },
  ];
  const columnNamess = [
    'Date Added',
    'Device Name',
    'Device ID',
    'Serial Number',
    'Status',
    'OTP',
    'Passcode',
    'Action',
  ];
  const [deviceSuccessModal, setDeviceSuccessModal] = useState(false);
  const handleDeviceSuccessModal = () => {
    setDeviceSuccessModal(true);
  };
  return (
    <ActionsWrapper>
      <CenterModal open={deleteModal} setOpen={setDeleteModal} width="580">
        <DeleteModal
          btnClick={ConfirmDelete}
          heading="Deactivate Device!"
          para="Are you sure you want to deactivate this device? all the data will be lost."
          btnText="Yes, Deactivate"
        />
      </CenterModal>
      <CenterModal open={deleteModalSuccess} setOpen={setDeleteModalSuccess} width="580">
        <SuccessModal
          heading="Device Deactivate Successfully!"
          btnText="Go Back"
          btnClick={() => setDeleteModalSuccess(false)}
        />
      </CenterModal>
      <CenterModal open={deviceSuccessModal} setOpen={setDeviceSuccessModal} width="580">
        <SuccessModal heading="Device Created Successfully!" para="Your device creation is successfully completed." />
      </CenterModal>
      <TableLayout
        onChangeFilters={filters => {
          setSearchQuery(_ => ({
            ..._,
            // searchText: filters,
            ...filters,
          }));
        }}
        tableHeading={
          <>
            <div className="arrow">
              <FaArrowLeft size={16} onClick={() => navigate(-1)} style={{ cursor: 'pointer' }} />{' '}
              {devices_data?.device[0]?.store_id?.title} Devices
            </div>
          </>
        }
        currentPage={searchQuery.page}
        pageSize={searchQuery.itemsPerPage}
        totalCount={totalCount}
        btnWidth={'40px'}
        btnType="download"
        placeholder="Search Devices"
        setSearchText={setSearchQuery}
        content={
          <Select
            placeholder="Status..."
            width="140px"
            noMargin
            options={FilterOptions}
            menuPosition="fixed"
            onChange={e =>
              setSearchQuery(prev => ({
                ...prev,
                filterStatus: e?.target?.value?.value,
              }))
            }
          />
        }
        btnText={
          hasPermission('device.create') && (
            <ModalContainer
              width="669"
              title="Add New Device"
              btnComponent={({ onClick }) => (
                <Button rounded width="141px" onClick={onClick}>
                  + Add Device
                </Button>
              )}
              content={({ onClose }) => (
                <AddDeviceModal onClose={onClose} onSubmit={handleDeviceSuccessModal} data={store_details_data} />
              )}
            />
          )
        }>
        <Table rowsData={product_rows} columnNames={columnNamess} noPadding loading={devices_loading} />
      </TableLayout>
    </ActionsWrapper>
  );
};

export default Devices;
